module.exports = __webpack_public_path__ + "img/skip-button.08866124.png";